import { useGetFormsList } from "./dataloader";
import { useRegDetail } from "../../../../shared/context/regDetail";
import { useSearchParams } from "react-router-dom";
import React from "react";
import { Base64Util } from "../../../../shared/utils/base64";
import QueryParamKey from "../../../../shared/enums/QueryParamKey";

/**
 * @name useRegistrationFormsListService
 * @description this includes logic related to Registration Forms List
 */

export default function useRegistrationFormsListService() {
  const { id: registrationId, emailSponsorBannerLocationUrl } = useRegDetail();
  const [searchParam] = useSearchParams();

  const sponsorAdList = React.useMemo(() => {
    if (!emailSponsorBannerLocationUrl) {
      return;
    }
    return [{ sponsorImgUrl: emailSponsorBannerLocationUrl }];
  }, [emailSponsorBannerLocationUrl]);

  const orgId = React.useMemo(() => searchParam.get(QueryParamKey.SPONSOR_ORG_ID), [searchParam]);
  const divisionId = React.useMemo(() => searchParam.get(QueryParamKey.DIVISION_ID), [searchParam]);
  const { data } = useGetFormsList(registrationId, Base64Util.decode(orgId), Base64Util.decode(divisionId));

  return {
    formsList: data?.registrationForms || [],
    description: data?.description || "",
    logo: data?.logo || "",
    title: orgId ? data?.sponsorOrganizationName : undefined,
    sponsorAdList,
    isListingForSponsorOrg: Boolean(orgId)
  };
}
